const items = [
  { label: "Get Started", link: "/docs/get-started" },
  { label: "Docs", link: "/docs/docs" },
  { label: "Animation Classes", link: "/docs/animation-classes", hide: true },
  {
    label: "Contributing",
    link: "https://github.com/all-animation/all-animation/blob/master/CONTRIBUTING.md",
  },
];

export default items;
